export default __webpack_public_path__ + "static/media/shareTunes1Low.65c4f80c.png";